interface StateForm {
  confirmation_file: any;
  student_id: string;
  municipality: string;
  level: string;
  competition_id: string;
  partner_id: string;
  event_id: string;
  date_finish: any;
  result: string;
  mentor_id: Array<string> | null;
}

interface Store {
  state: StateForm | any;
  addLevel: any;
  addCompetition: any;
  addProgressFormData: any;
  cleanProgressState: any;
}

const defaultStore: StateForm = {
  confirmation_file: { name: '' },
  student_id: '',
  municipality: '',
  level: '',
  competition_id: '',
  partner_id: '',
  event_id: '',
  date_finish: '',
  result: '',
  mentor_id: null,
};

export const progressStore: Store = {
  state: defaultStore,

  addLevel(level: string) {
    this.state.level = level;
  },

  addCompetition(competition: string) {
    this.state.competition_id = competition;
  },

  addProgressFormData(data: any) {
    this.state = { ...data };
  },

  cleanProgressState() {
    this.state = defaultStore;
  },
};



// WEBPACK FOOTER //
// ./src/pages/profile/views/progress/forms/ProgressStore.ts